const posts = state => state.posts;
const userWall = state => state.userWall;
const memberWall = state => state.memberWall;

export default {
  posts,
  userWall,
  memberWall
};
